import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import WishlistForm from '../components/WishlistForm';
import WishlistGrid from '../components/WishlistGrid';

const WishlistPage = () => {
  const { id } = useParams(); // get id from URL param
  const [refreshKey, setRefreshKey] = useState(0);
  const [showForm, setShowForm] = useState(false);

  const handleAdd = () => {
    setShowForm(false);
    setRefreshKey((prev) => prev + 1);
  };

  const handleBack = () => {
    setShowForm(false);
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h2 className="text-2xl font-bold mb-4">Our Wishlist</h2>

      {!showForm && (
        <div className="mb-6 w-full">
          <button
            onClick={() => setShowForm(true)}
            className="btn-primary w-full"
          >
            Add Wishlist
          </button>
        </div>
      )}

      {showForm ? (
        <div>
          <WishlistForm id={id} onAdd={handleAdd} />
          <button
            onClick={handleBack}
            className="mt-4 text-sm text-gray-600 hover:underline"
          >
            ← Back to Wishlist
          </button>
        </div>
      ) : (
        <WishlistGrid key={refreshKey} id={id} />
      )}
    </div>
  );
};

export default WishlistPage;
